

function feeManagement() {

  let feeService = [
    {
      name: "Fee Mangement",
      icon: "fee-management",
      logoName: "FEE",
      // flag: "voucherRequired",
      displayService: "feeManagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/fee-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const feeMaster = () => {
    const profileArr = [
      {
        path: "/index/fee",
        name: "Fee Management",
        icon: "fee-master",
        logoName: "FEE",
        flag: "FEE MANAGEMENT",
      },
    ];

  

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const feeMarkup=()=>{
    const profileArr = [
      {
        path: "/index/feemarkup",
        name: "Fee Markup",
        icon: "fee-master",
        logoName: "FEE",
        flag: "FEE MARKUP",
      },
    ];

    return profileArr;

  }

  let a = dashboard();
  let b = feeMaster();  
  let c = feeMarkup();

  feeService[0].items = [...a, ...b, ...c];

  return feeService;
}

export default feeManagement;
